// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-confirm-rdsu-3-g-2-p-js": () => import("../src/pages/confirm/RDSU3G2P.js" /* webpackChunkName: "component---src-pages-confirm-rdsu-3-g-2-p-js" */),
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

